import { availablePmpt } from 'consts';
import React, { PureComponent } from 'react';

import Spinner from 'components/spinner/Spinner';
import { ISaferPayScriptContext } from 'types/SaferPayScriptContext';
import CardBM from './bm/CardBM';
import CardWidget from './Card.styles';
import { ICardProps } from './Card.types';
import CardWL from './wl/CardWL';
import withCardContext from '../../hoc/withCardContext';
import { ICardContext } from '../../types/CardContext';
import CardWLGrouped from './wlGrouped/CardWLGrouped';

enum ViewType {
  AUTOPAY_CARD,
  WORLDLINE_CARD,
  WORLDLINE_GROUPED_CARDS,
}

class Card extends PureComponent<ICardProps & ISaferPayScriptContext & ICardContext> {
  render() {
    const { isCardComponentLoading, paymentMethods } = this.props;
    const isCardGrouped = paymentMethods.length > 1;
    let determinedViewType;
    if (isCardGrouped) {
      determinedViewType = ViewType.WORLDLINE_GROUPED_CARDS;
    } else if (paymentMethods[0].pmpt === availablePmpt.WORLDLINE) {
      determinedViewType = ViewType.WORLDLINE_CARD;
    } else {
      determinedViewType = ViewType.AUTOPAY_CARD;
    }
    const cardMethod =
      paymentMethods.find(pm => pm.id.toString() === '2002') ||
      paymentMethods.find(pm => pm.id.toString() === '2202') ||
      paymentMethods[0];
    const cardWidgetData = {
      ...this.props,
      widgetUrl: cardMethod.widgetUrl,
    };
    const cardComponent = () => {
      switch (determinedViewType) {
        case ViewType.AUTOPAY_CARD:
          return <CardBM {...cardWidgetData} />;
        case ViewType.WORLDLINE_CARD:
          return <CardWL {...cardWidgetData} />;
        case ViewType.WORLDLINE_GROUPED_CARDS:
          return <CardWLGrouped {...cardWidgetData} />;
        default:
          return <CardWL {...cardWidgetData} />;
      }
    };
    return (
      <>
        <Spinner isLoading={isCardComponentLoading} />
        <CardWidget isVisible={!isCardComponentLoading}>{cardComponent()}</CardWidget>
      </>
    );
  }
}

export default withCardContext(Card);
